import React from "react";
import PageHeader from "../components/PageHeader";
import { useLang } from "../contexts/LangContext";
import { ShieldAlert, Radio, Anchor } from "lucide-react";

export default function Motor() {
  const { t, img, visible, sectionOrder } = useLang();
  const ord = (id) => sectionOrder("motor", id, ["security", "boats", "brevets"]);
  return (
    <div data-testid="motor-page" className="flex flex-col">
      <PageHeader eyebrow={t.motor.eyebrow} title={t.motor.title} lead={t.motor.lead}
        image={img("motor", "header", "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400")} />

      {/* Security */}
      {visible("motor", "security") && (
      <section style={{ order: ord("security") }} className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <ShieldAlert className="w-10 h-10 text-club-red mb-6" strokeWidth={1.25} />
            <div className="label-eyebrow text-club-red mb-4">{t.motor.securityTitle}</div>
            <h2 className="font-serif text-3xl lg:text-4xl font-light text-navy">{t.motor.securityTitle}</h2>
            <div className="divider-gold mt-5" />
            <p className="text-slate-600 mt-6 leading-relaxed text-lg">{t.motor.securityText}</p>
          </div>
          <div className="md:col-span-5">
            <img src={img("motor", "security", "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?w=1200")} alt="" className="w-full aspect-square object-cover" />
          </div>
        </div>
      </section>
      )}

      {/* Boats */}
      {visible("motor", "boats") && (
      <section style={{ order: ord("boats") }} className="py-20 bg-sand">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
          <Anchor className="w-9 h-9 text-club-yellow-dark mb-6" strokeWidth={1.25} />
          <div className="label-eyebrow text-club-red mb-4">{t.motor.boatsTitle}</div>
          <h2 className="font-serif text-3xl lg:text-4xl font-light text-navy">{t.motor.boatsTitle}</h2>
          <div className="divider-gold mt-5" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {(t.motor.boats || []).map((b, i) => (
              <div key={i} className="bg-white border border-slate-200" data-testid={`motor-boat-${i + 1}`}>
                <div className="aspect-video overflow-hidden">
                  <img src={b.main_image || (b.images || [])[0] || ""} alt={b.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <div className="text-[10px] uppercase tracking-widest text-club-yellow-dark mb-2 font-semibold">{b.tag}</div>
                  <div className="font-serif text-xl text-navy">{b.name}</div>
                  <div className="text-sm text-slate-600 mt-2">{b.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* Brevets */}
      {visible("motor", "brevets") && (
      <section style={{ order: ord("brevets") }} className="py-20 bg-navy text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
          <Radio className="w-9 h-9 text-club-yellow mb-6" strokeWidth={1.25} />
          <div className="label-eyebrow text-club-yellow mb-4">{t.motor.brevetsTitle}</div>
          <h2 className="font-serif text-3xl lg:text-4xl font-light">{t.motor.brevetsTitle}</h2>
          <div className="divider-gold mt-5" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            {t.motor.brevetsList.map((b, i) => (
              <div key={i} className="bg-white/5 border border-white/10 p-8 hover:border-club-yellow transition-colors" data-testid={`motor-brevet-${i}`}>
                <div className="font-serif text-2xl text-club-yellow mb-3">{b.name}</div>
                <div className="w-10 h-px bg-club-red mb-4" />
                <p className="text-slate-300 text-sm">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      )}
    </div>
  );
}
